import { useEffect, useState } from 'react';
import Modal from '../Modal';
import { repositorioFazenda } from '../../sync/repositories/fazendas';
import { extrairMensagensErro } from '../../utils/errorUtils';

/**
 * Modal de cadastro rápido de Fazenda.
 * Coleta apenas o campo mínimo necessário (nome) para permitir um
 * cadastro express durante o preenchimento de outro formulário.
 * Após salvar, a lista de Fazendas deve ser recarregada pelo pai e a
 * nova fazenda selecionada automaticamente.
 */
export default function ModalCadastroFazenda({ isOpen, onClose, onSuccess }) {
  const [nome, setNome] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [erros, setErros] = useState([]);

  useEffect(() => {
    if (!isOpen) {
      setNome('');
      setErros([]);
      setSalvando(false);
    }
  }, [isOpen]);

  const handleSalvar = async (e) => {
    e?.preventDefault?.();
    if (!nome.trim()) { setErros(['O nome é obrigatório.']); return; }
    setSalvando(true);
    setErros([]);
    try {
      const resp = await repositorioFazenda.criar({
        nome: nome.trim(),
        hectares: 0,
        cidade: 'Sem informação',
        estado: 'Sem informação',
        atividade_principal: 'Sem informação',
      });
      onSuccess?.(resp.data);
      onClose?.();
    } catch (error) {
      setErros(extrairMensagensErro(error));
    } finally {
      setSalvando(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={salvando ? () => {} : onClose} title="Cadastrar Nova Fazenda">
      <form onSubmit={handleSalvar} className="space-y-4">
        <p className="text-sm text-gray-600">
          Cadastro rápido. Você poderá complementar os demais dados (hectares, cidade, estado, atividade principal) na tela de Gestão de Fazendas depois.
        </p>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Nome *</label>
          <input
            type="text"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            className="w-full border border-gray-300 p-2 rounded focus:ring-2 focus:ring-green-300"
            placeholder="Ex: Fazenda São João"
            autoFocus
            disabled={salvando}
          />
        </div>
        {erros.length > 0 && (
          <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded p-3 space-y-1">
            {erros.map((m, i) => <div key={i}>{m}</div>)}
          </div>
        )}
        <div className="flex justify-end gap-2 pt-2">
          <button type="button" onClick={onClose} disabled={salvando}
            className="px-4 py-2 rounded border border-gray-300 text-gray-700 hover:bg-gray-100 disabled:opacity-50">
            Cancelar
          </button>
          <button type="submit" disabled={salvando}
            className="px-4 py-2 rounded bg-blue-600 hover:bg-blue-700 text-white disabled:bg-blue-300">
            {salvando ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
      </form>
    </Modal>
  );
}
